import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { publicAPI } from '../../lib/api';
import { Wrench, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

export default function ServicesPage() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    publicAPI.getServices().then(r => setServices(r.data));
  }, []);

  return (
    <>
      <Helmet>
        <title>Endustriyel Hizmetler | Teklif Al</title>
        <meta name="description" content="CNC torna, lazer kesim, kalip uretimi ve daha fazla endustriyel uretim hizmeti." />
      </Helmet>

      <section className="bg-slate-50 py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-semibold mb-4" data-testid="services-title">Endustriyel Hizmetler</h1>
          <p className="text-muted-foreground max-w-2xl">Turkiye genelinde sunulan endustriyel uretim hizmetleri. Ihtiyaciniz olan hizmeti secin ve teklif alin.</p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map(s => (
              <Card key={s.id} className="bg-white hover:shadow-md transition-shadow" data-testid={`service-${s.slug}`}>
                <CardContent className="p-6">
                  <Wrench className="h-10 w-10 text-[hsl(221,83%,22%)] mb-4" />
                  <h2 className="text-xl font-semibold mb-3">{s.name}</h2>
                  <p className="text-sm text-muted-foreground mb-4 leading-relaxed">{s.summary}</p>
                  <Link to="/teklif-al">
                    <Button variant="outline" size="sm" className="w-full" data-testid={`service-cta-${s.slug}`}>
                      Teklif Al <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
